import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static get targets() { return ['checkbox', 'field'] }

  toggle() {
    const checked = this.checkboxTarget.checked
    this.fieldTarget.disabled = !checked
    if (!checked) this.fieldTarget.value = ''
  }

  input() {
    if (this.fieldTarget.value) {
      this.checkboxTarget.checked = true
      this.fieldTarget.disabled = false
    }
  }
}
